import React, { useEffect, useState } from "react";
import { getImageUrl } from "@/config/images";

/*
 * The food photos as a GTA loading-screen comic page: panels of different sizes with slanted cuts and
 * ink frames, slamming in one after the other once `play` is set, the loading bar filling underneath.
 * Layout (grid areas a-g and w, the wide one) and slams are in App.css ("COMIC PAGE").
 * photos: in panel order, each a path or { src, focus, zoom, whole } (focus: the point kept in frame, as
 * in object-position; zoom: closer than the panel's own fit; whole: show all of the photo, with a blurred
 * copy of it filling the rest of the panel).
 */
const PANELS = [
  { area: "a", cut: "polygon(0 0, 100% 0, 95% 100%, 0 100%)" },
  { area: "b", cut: "polygon(4% 0, 100% 0, 100% 100%, 0 100%)" },
  { area: "w", cut: "polygon(0 0, 100% 0, 100% 100%, 3% 100%)" },
  { area: "c", cut: "polygon(0 0, 100% 0, 100% 86%, 0 100%)" },
  { area: "d", cut: "polygon(0 0, 100% 7%, 100% 100%, 0 100%)" },
  { area: "e", cut: "polygon(0 12%, 100% 0, 97% 100%, 0 100%)" },
  { area: "f", cut: "polygon(0 0, 96% 0, 100% 100%, 4% 100%)" },
  { area: "g", cut: "polygon(3% 0, 100% 0, 100% 100%, 0 100%)" },
];
const SLAM_MS = 170;

const ComicPage = ({ photos, play }) => {
  const [shown, setShown] = useState(0);

  useEffect(() => {
    if (!play || shown >= PANELS.length) return undefined;
    const timer = setTimeout(() => setShown((n) => n + 1), shown === 0 ? 150 : SLAM_MS);
    return () => clearTimeout(timer);
  }, [play, shown]);

  return (
    <>
      <div className="comic-page">
        {PANELS.map((panel, i) => {
          const tilt = i % 2 ? 1 : -1;
          const photo = typeof photos[i] === "string" ? { src: photos[i] } : photos[i];
          return (
            <div
              key={panel.area}
              className={`comic-panel ${i < shown ? "comic-in" : ""}`}
              style={{ gridArea: panel.area, clipPath: panel.cut, "--tilt": tilt, "--i": i }}
            >
              <div className="comic-art" style={{ clipPath: panel.cut }}>
                {photo.whole && <img className="comic-fill" src={getImageUrl(photo.src)} alt="" loading="lazy" />}
                <img
                  className={photo.whole ? "comic-whole" : undefined}
                  src={getImageUrl(photo.src)}
                  alt={`Gallery ${i + 1}`}
                  loading="lazy"
                  style={{ objectPosition: photo.focus, transformOrigin: photo.focus, "--zoom": photo.zoom }}
                />
              </div>
            </div>
          );
        })}
      </div>
      <div className={`comic-loading ${play && shown < PANELS.length ? "comic-loading-on" : ""}`} aria-hidden="true">
        <div style={{ width: `${(shown / PANELS.length) * 100}%` }} />
      </div>
    </>
  );
};

export default ComicPage;
